// extracted by mini-css-extract-plugin
module.exports = {"socialStrip":"socialStrip-module--socialStrip--3YrLR","social":"socialStrip-module--social--3OxCN"};